import { Box, Typography } from "@mui/material";
import Iconify from "../../../../reusable-components/iconify";

export default function IconWithText({ text, icon, sx, variant = "body2" }) {
  return <Typography component="div" variant={variant} sx={{ py: 0.5, maxWidth: "100%", ...sx }}>
    <Box component="span" sx={{ mr: 0.5, minWidth: 16 }}><Iconify sx={{ mb: "-3px" }} icon={icon} width={16} height={16} color="secondary" clickable={false} /></Box>    
    {text}
  </Typography>
}